const isPrimitive = (value) =>
    typeof value === 'string'
    || typeof value === 'number'
    || typeof value === 'boolean';

/**
 * Convert logger meta into OTLP-safe attribute values (primitives or JSON strings).
 *
 * @param {*} value
 * @returns {string|number|boolean|undefined}
 */
const toOtlpAttributeValue = (value) => {
    if (isPrimitive(value)) {
        return value;
    }

    if (value === undefined || value === null || value === '') {
        return undefined;
    }

    if (Array.isArray(value) || typeof value === 'object') {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }

    return String(value);
};

/**
 * Build OTLP log attributes from a logger record meta object.
 *
 * @param {Object} data
 * @returns {Object}
 */
export const toOtlpLogAttributes = (data = {}) =>
    Object.fromEntries(
        Object.entries(data)
            .map(([key, value]) => [key, toOtlpAttributeValue(value)])
            .filter(([, value]) => value !== undefined),
    );
